import { Config } from '@stencil/core';
import { reactOutputTarget } from '@stencil/react-output-target';
import tailwind, { tailwindHMR } from 'stencil-tailwind-plugin';
import tailwindConfig from './tailwind.config';
import { angularOutputTarget } from '@stencil/angular-output-target';

export const config: Config = {
  namespace: 'pancake',
  taskQueue: 'async',
  sourceMap: true,
  devServer: {
    reloadStrategy: 'pageReload',
  },
  extras: {
    experimentalImportInjection: true,
  },
  globalStyle: 'src/global/global.css',
  plugins: [
    tailwind({
      tailwindConf: tailwindConfig,
    }),
    tailwindHMR(),
  ],
  outputTargets: [
    {
      type: 'dist',
      esmLoaderPath: '../loader',
      copy: [{ src: 'fonts', dest: 'assets/fonts' }],
    },
    {
      type: 'www',
      serviceWorker: null, // disable service workers
      copy: [{ src: 'fonts', dest: 'assets/fonts' }],
    },
    {
      type: 'dist-custom-elements',
      includeGlobalScripts: false,
    },
    {
      type: 'docs-readme',
    },
    {
      type: 'www',
      serviceWorker: null, // disable service workers
    },
    angularOutputTarget({
      componentCorePackage: '@lendingsolution/pancake',
      directivesProxyFile: './../../../libs/ngx-pancake/src/lib/stencil-generated/proxies.ts',
      directivesArrayFile: './../../../libs/ngx-pancake/src/lib/stencil-generated/directives.ts',
    }),
    // reactOutputTarget({
    //   componentCorePackage: '@ineo/pancake',
    //   proxiesFile: './../../../libs/pancake-react/src/proxies/index.ts',
    // }),
  ],
  testing: {
    browserHeadless: 'new',
  },
};
